import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  Suspense,
  lazy,
} from "react";
import "./herosection.css";

// images import
import BlueButton from "./BlueButton";
const Grid = lazy(() => import("animated-grid-lines"));

function Herosection() {
  const [scrolledIn, setScrolledIn] = useState(false);
  const scrolledInRef = useRef(false);

  const handleScroll = () => {
    requestAnimationFrame(() => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      const isScrolled =
        scrollY >= viewportHeight * 0.02 && scrollY <= viewportHeight * 0.5;

      if (scrolledInRef.current !== isScrolled) {
        scrolledInRef.current = isScrolled;
        setScrolledIn(isScrolled);
      }
    });
  };

  const handleScrollToViewPort = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="hero-section-container">
      <Suspense fallback={<div>...</div>}>
        <Grid
          colors={["#00FFFF"]}
          speed={20}
          squareSize={100}
          maxLineLength={100}
          lineWidth={0.5}
          gridColor="rgba(255, 255, 255, 0.1)"
          className="animated-gridview"
        />
      </Suspense>

      <div className="hero-section-wrapper">
        <div className="main_hero_section">
          <div className="hero-section-text-container">
            <div
              className={`hero-section-images ${
                scrolledIn && " animate-image"
              }`}
            >
              <img src="/images/Face Match.svg" alt="" loading="lazy" />
              <img src="/images/Document OCR.svg" alt="" loading="lazy" />
              <img src="/images/Skip Tracing.svg" alt="" loading="lazy" />
              <img src="/images/Name Match.svg" alt="" loading="lazy" />
              <img src="/images/Liveliness Check.svg" alt="" loading="lazy" />
              <img src="/images/Email Bounce.svg" alt="" loading="lazy" />
              <img src="/images/TamperProof.svg" alt="" loading="lazy" />
              <img
                src="/images/Financial Statement.svg"
                alt=""
                loading="lazy"
              />
              <img src="/images/IDProof.svg" alt="" loading="lazy" />
              <img src="/images/OCRProof.svg" alt="" loading="lazy" />
              <img src="/images/Trustiify.svg" alt="" loading="lazy" />
              <img src="/images/Face Match.svg" alt="" loading="lazy" />
              <img src="/images/Document OCR.svg" alt="" loading="lazy" />
              <img src="/images/Skip Tracing.svg" alt="" loading="lazy" />
              <img src="/images/Name Match.svg" alt="" loading="lazy" />
              <img src="/images/Liveliness Check.svg" alt="" loading="lazy" />
            </div>
            <div
              className={`hero-section-text-inner-container ${
                scrolledIn && "animate-image"
              }`}
            >
              Going Beyond
            </div>
            <h3 className="hero-section-subheading">Financial Score</h3>
            <p>
              The easiest way to verify emails, identities, and detect forged
              documents: all in real time.
            </p>
            <div className="hero-section-btn-group">
              <BlueButton
                text={"Try For Free"}
                styles={{
                  width: "100%",
                  textWrap: "nowrap",
                  pointerEvents: "auto",
                  backgroundImage:
                    "radial-gradient(circle at 50% 50%, #DFFF8E, #AFF500 91%)",
                  color: "#6D2FEC",
                  size: "1rem",
                  border: "1px solid #A0E100",
                }}
                onClick={() => handleScrollToViewPort("book-a-demo")}
              />
              <BlueButton
                text={"Explore the Suite"}
                styles={{
                  width: "100%",
                  textWrap: "nowrap",
                  pointerEvents: "auto",
                  backgroundImage:
                    "radial-gradient(circle at 50% 50%, #ffffff, #ffffff 91%)",
                  color: "#6D2FEC",
                  size: "1rem",
                  border: "1px solid #A0E100",
                }}
                onClick={() => handleScrollToViewPort("learn-more")}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(Herosection);
